
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ToggleButton extends Vue {
  @Prop({ type: String, required: true }) public option1: string;
  @Prop({ type: String, required: true }) public option2: string;
  @Prop({ type: Boolean, required: false }) public option_all: boolean;
  @Prop({ type: Boolean, required: false }) public readonly disabled: boolean;
  @Prop() public value: boolean | null;

  public toggleClicked(value) {
    if (!this.disabled) {
      this.$emit('changed', value);
    }
  }
}
